

function disableDuplicateJS() {
  // disables duplicate css link files.
  var nodes       = document.getElementsByTagName("script"),
      foundNodes  = [],
      splitFirst  = 'assets/',
      splitLast   = '.js';
  for (const element of nodes) {
    if (element.src == null && element.getAttribute('data-src') == null) return false;
    var el        = element,
        elSrc     = el.src == null ? el.getAttribute('data-src') : el.src,
        lnk       = elSrc.split(splitFirst).pop().split(splitLast)[0];
    // console.log(elSrc)
    if (elSrc.includes(splitFirst)) {
      if (foundNodes.includes(lnk)) {
        // el.setAttribute('disabled', true);
        el.remove();
      } else {
        foundNodes.push(lnk);
      }
    }
  }
}

function disableDuplicateCSS() {
  // disables duplicate css link files.
  var nodes       = document.getElementsByTagName("link"),
      foundNodes  = [],
      splitFirst  = 'assets/',
      splitLast   = '.css';
  for (const element of nodes) {
    var el        = element,
        elHref    = el.href,
        lnk       = elHref.split(splitFirst).pop().split(splitLast)[0];
    if (elHref.includes(splitFirst)) {
      if (foundNodes.includes(lnk)) {
        el.setAttribute('disabled', true);
      } else {
        foundNodes.push(lnk);
      }
    }
  }
}

function disableDuplicateInlineCSS() {
  // disables duplicate inline css style files.
  var nodes           = document.getElementsByTagName("style"),
      foundInlineCSS = [];
  for (const element of nodes) {
    var el        = element,
        elData    = el.dataset.id,
        lnk       = elData;
    if (typeof elData !== 'undefined') {
      if (foundInlineCSS.includes(lnk)) {
        // el.setAttribute('disabled', true);
        el.remove();
      } else {
        foundInlineCSS.push(lnk);
      }
    }
  }
}

function disableDuplicates(argument) {
  disableDuplicateJS();
  disableDuplicateCSS();
  disableDuplicateInlineCSS();
}

function parentVisible(elem) {
  var count,
      elemPar,
      nodes = [];
  nodes.push(elem);
  while( (elem.parentNode && elem.parentNode.nodeName != 'BODY' && elem.parentNode.nodeName != 'HTML' ) || count < 10 ) {
    count++
    nodes.unshift(elem.parentNode);
    elemPar = elem.parentNode;
    if ( elemPar ) {
      var styles = window.getComputedStyle(elemPar)
      if ( styles.display === 'none' || styles.visibility === 'hidden' || styles.opacity === '0' ) {
        return false;
      } else if (elemPar.nodeName == 'HEAD') {
        return elemPar;
        break
      } else {
        return elemPar;
        break
      }
    }
  }
  return elemPar;
}

function checkAndLoad(lazyElements,loadLazy) {
  var lazyItems = [].slice.call(document.querySelectorAll(lazyElements));
  if (loadLazy != false) {
    disableDuplicates();
    var visibleLinks = [];
    lazyItems.forEach(function(link, index) {
      var parLink = parentVisible(link);
      if (parentVisible(link)) {
        visibleLinks.push(parLink);
      } else {
        loadItem(link);
      }
    })
    itemIsVisible(visibleLinks,lazyItems);
  } else {
    loadAllItems(lazyItems) 
  }

  function loadItem(el) {
    // el.media='all';
    if (el.nodeName == 'LINK') {
      el.href = el.dataset.href;
    } else {
      el.src = el.dataset.src;
    }
  }

  function itemIsVisible(arr, lazyItems) {
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      let elObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          var el = entry.target;
          // console.log(el)
          if ( entry.isIntersecting || ( window.scrollY > (el.offsetTop + el.offsetHeight) ) ) {
            var innerItems = el.querySelectorAll(lazyElements);
            innerItems.forEach(function(item){
              loadItem(item);
            })
            elObserver.unobserve(el);
          }
        });
      });
      arr.forEach(function(el) {
        disableDuplicates();
        elObserver.observe(el);
      });
    } else {
      console.log('observer failed')
      loadAllItems(lazyItems)
    }
  }

  function loadAllItems(lazyItems) {
    disableDuplicates();
    lazyItems.forEach(function(item, index) {
      loadItem(item);
      // console.log(item)
    });
  }
}

function LazyImages() {
  // To Do: figure out how to only see "visible" images, not ones hidden in menus till needed
  function isVisible(elem) {
    const styles = window.getComputedStyle(elem)      
    return styles.display !== 'none' && styles.visibility !== 'hidden'
    // return styles.display !== 'none' && styles.visibility !== 'hidden' && parentVisible(elem)
  }
  var lazyClass = 'lazyload',
      loadedClass = 'lazyloaded',
      ignoreClass = 'defer',
      lazyImages = [].slice.call(document.querySelectorAll('img.'+lazyClass+':not(.'+ignoreClass+')'));
  
  setTimeout(function (argument) {

    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting ) {

            let lazyImage = entry.target,
                lazySrc = lazyImage.dataset.src,
                lazySrcSet = lazyImage.dataset.srcset,
                lazySizes = lazyImage.dataset.sizes;

            lazyImage.src = lazySrc;
            lazyImage.srcset = lazySrcSet;
            lazyImage.sizes = lazySizes;
            lazyImage.addEventListener('load', loaded)

            function loaded() {
              // setTimeout(function () {
                lazyImage.classList.add(loadedClass);
                lazyImage.classList.remove(lazyClass);
                lazyImageObserver.unobserve(lazyImage);
              // },1000)
            }
          }
        });
      });
      lazyImages.forEach(function(lazyImage) {
        if (lazyImage.offsetWidth < window.innerWidth) {
          let newSize = Math.round(lazyImage.offsetWidth * 2) + 'px';
          let newLazySize = '(min-width: ' + window.innerWidth + 'px) ' + newSize + ',';
          let lazySizes = lazyImage.dataset.sizes;
          lazySizes = newLazySize + lazySizes;
          lazyImage.dataset.sizes = lazySizes;
        }
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      var lazyloadIThrottleTimeout;
      function lazyload () {
        if (lazyloadIThrottleTimeout) {
          clearTimeout(lazyloadIThrottleTimeout);
        }    
        lazyloadIThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyImages.forEach(function(img) {
            if (img.offsetTop < (window.innerHeight + scrollTop)) {

              img.src = img.dataset.src;
              img.srcset = img.dataset.srcset;
              img.sizes = img.dataset.sizes;
              img.classList.remove(lazyClass);
              // console.log(img)
            }
          });
          if (lazyImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("load", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }
      document.addEventListener("scroll", lazyload);
      window.addEventListener("load", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  },100)
}

function updateHeightVar(el, v) {
  var prevH = 0;
  var itm = document.querySelector(el);

  runTwice()
  window.addEventListener('resize', runTwice);
  window.addEventListener('scroll', runTwice);

  function runTwice() {
    initH()
    setTimeout(function() {
      initH(true)
    }, 100);
  }

  function initH(force) {
    var H = itm.clientHeight;
    if (H != prevH || force == true) {
      // console.log('run') 
      // Then we set the value in the --header-height custom property to the root of the document
      document.documentElement.style.setProperty(v, `${H}px`);
      prevH = H;
    }
  }
}

function VideoRatio() {
  var videos = [].slice.call(document.querySelectorAll('.video-ratio:not(.for-modal) iframe, .video-ratio:not(.for-modal) video'));
  window.addEventListener("load", initRatio);
  window.addEventListener("resize", initRatio);
  window.addEventListener("orientationChange", initRatio);
  function initRatio() {
    var winWdth           = window.innerWidth,
        ratio             = 0.56;
    if (videos.length) {
      videos.forEach(function(video) {
        if (typeof video.getAttribute('data-video-ratio') !== 'undefined') {
          ratio           = video.getAttribute('data-video-ratio');
        }
        var videoPar      = video.closest('div'),
            videoParHght  = videoPar.offsetHeight,
            cssHght       = videoParHght,
            cssWdth       = cssHght / ratio;
        if (cssWdth < winWdth) {
          var cssWdth     = winWdth,
              cssHght     = cssWdth * ratio;
        }
        video.setAttribute('style', 'width: ' + cssWdth + 'px !important;height: ' + cssHght + 'px !important;')
      })
    }
  }
}

function watchForElement(el, method) {
  let loopCount = 0,
      loopMax = 100,
      loopDelay = 200;
  let checkIfElementExists = setInterval(function() {
    loopCount++;
    if (loopCount > loopMax) {
      clearInterval(checkIfElementExists);
      // console.log(el + ' not found within ' + loopMax + ' iterations.');
      return false;
    }
    let element = document.querySelectorAll(el)[0]; // Select the element using querySelectorAll
    if (element) {
      clearInterval(checkIfElementExists);
      method(element);
    }
  }, loopDelay);
}

// var chkEl = '[data-testid="ShopifyPay-button"]';
// watchForElement(chkEl,function(el) {
//   el.parent().hide()
// })

function move(elem, moveElemHere, placement) {
  if ( placement == 'before' ) {
    moveElemHere.before(elem);
  } else if ( placement == 'after' ) {
    moveElemHere.after(elem)
  } else if ( placement == 'prepend' ) {
    moveElemHere.prepend(elem)
  } else {
    moveElemHere.append(elem)
  }
}

function positionChange(elemToMove, mobPar, dskPar, mobPlcmt, dskPlcmt, changeAt) {
  var elemToMove    = document.querySelector(elemToMove),
      mobPar        = document.querySelector(mobPar);
  
  if (!elemToMove && !mobPar) return false;

  var dskPar        = elemToMove.closest(dskPar),
      changeAt      = typeof changeAt == 'undefined' ? 750 : changeAt,
      mobPlcmt      = typeof mobPlcmt == 'undefined' ? 'append' : mobPlcmt,
      dskPlcmt      = typeof dskPlcmt == 'undefined' ? 'append' : dskPlcmt,
      mobChk        = 'mob',
      deskChk       = 'desk',
      moved         = deskChk;

  initPos();
  window.addEventListener("resize", initPos);

  function initPos() {
    var wdth        = window.innerWidth,
        above       = wdth >= changeAt && moved != deskChk,
        below       = wdth < changeAt && moved != mobChk;
    if ( above ) {
      move(elemToMove, dskPar, dskPlcmt);
      moved         = deskChk;
    } 
    if ( below ) {
      move(elemToMove, mobPar, mobPlcmt);
      moved         = mobChk;
    } 
  }
}

function moveDeliverr(item, parents, destination, placement) {
  watchForElement(item,function(el) {
    setTimeout(function () {
      document.querySelectorAll(item).forEach(function(element) {
        var parent  = element.closest(parents);
        move(
          element,
          parent.querySelectorAll(destination)[0],
          placement
        );
      });
    },200)
  }); 
}

function moveDeliverrCards() {
  var deliverrParents       = '.stacked .product-card',
      deliverr              = deliverrParents + ' deliverr',
      destination           = '.image--outer',
      placement             = 'after';
  moveDeliverr(deliverr, deliverrParents, destination, placement)
}

function moveDeliverrPDP() {
  var deliverrParents       = '.product__info-wrapper',
      deliverr              = deliverrParents + ' deliverr',
      destination           = '.price',
      placement             = 'before';
  moveDeliverr(deliverr, deliverrParents, destination, placement)
}

function getSiblings(elem) {
  // Setup siblings array and get the first sibling
  var siblings = [];
  var sibling = elem.parentNode.firstChild;
  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling
  }
  return siblings;
}

function simpleTabs() {
  var dataTitle = 'data-tab-title',
      dataContent = 'data-tab-content',
      dataContainer = 'data-tab-container',
      tabTrigger = '['+dataTitle+']',
      tabContent = '['+dataContent+']',
      tabContainer = '['+dataContainer+']',
      classActiveTab = 'tab--active',
      tabs = document.querySelectorAll(tabTrigger);
  function swapActive(target) {
    var siblings = getSiblings(target);
    siblings.forEach(function (sibling, index) {
      sibling.classList.remove(classActiveTab);
    });
    target.classList.add(classActiveTab); 
  }
  tabs.forEach(function (tab, index) {
    var container = tab.closest(tabContainer),
        tabID = tab.getAttribute(dataTitle),
        content = container.querySelector('['+dataContent+'="'+tabID+'"]');
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      // swap current active tab
      swapActive(tab);
      // swap current active content
      swapActive(content);
    });
    container.querySelector(tabTrigger).click();
  });
}

function simpleScrollAnimations() {
  var elementTriggers = document.querySelectorAll('[data-scroll-trigger]'),
      elementInViewClass = 'in-view',
      inViewOffset = (window.outerHeight * 0.5),
      scrollPos = (window.pageYOffset - inViewOffset);
  elementTriggers.forEach(function (element, index) {
    var elementScrollOffset = element.offsetTop,
        elementScrollID = element.getAttribute('data-scroll-trigger'),
        elementAddClass = document.querySelector('[data-scroll-addclass="'+elementScrollID+'"]');
    if (scrollPos >= elementScrollOffset) {
      elementAddClass.classList.add(elementInViewClass);
    } else {
      elementAddClass.classList.remove(elementInViewClass);
    }
  });
}

function beforeAfterView() {
  var baContainer = '[data-before-after]',
    baTrigger = '[data-before-after-trigger]',
    baImage = '[data-before-after-image]',
    beforeAfter = document.querySelectorAll(baContainer),
    beforeAfterMaxWidth = null,
    dragTrigger = null, // Object of the element to be moved
    beforeImage = null,
    x_pos = 0, // Stores x  coordinates of the mouse pointer
    x_elem = 0; // Stores left values (edge) of the element



  // Will be called when user starts dragging an element
  function _drag_init(elem) {
    // Store the object of the element which needs to be moved
    dragTrigger = elem;
    beforeImage = elem.closest(baContainer).querySelector(baImage);
    beforeAfterMaxWidth = elem.closest(baContainer).offsetWidth;
    x_elem = x_pos - dragTrigger.offsetLeft;
  }

  // Will be called when user dragging an element
  function _move_elem(e) {
    x_pos = document.all ? window.event.clientX : e.pageX;
    offset = x_pos - x_elem;
    farthestLeft = beforeAfterMaxWidth * 0.05;
    farthestRight = beforeAfterMaxWidth * 0.95;
    leftOpacity = offset / (beforeAfterMaxWidth/2);
    rightOpacity = 2 - leftOpacity;

    if ( 
        dragTrigger !== null 
        && beforeImage !== null 
        && beforeAfterMaxWidth !== null 
        && offset > farthestLeft 
        && offset < farthestRight 
      ) {
      dragTrigger.style.left = offset + 'px';
      beforeImage.style.setProperty('--offset', `${offset}px`);
      dragTrigger.style.setProperty('--opacity--left', `${leftOpacity}`);
      dragTrigger.style.setProperty('--opacity--right', `${rightOpacity}`);
    }
  }

  // Destroy the object when we are done
  function _destroy() {
    dragTrigger = null;
    beforeImage = null;
    beforeAfterMaxWidth = null;
  }

  // Bind the functions...
  beforeAfter.forEach(function (element, index) {
    var trigger = element.querySelector('[data-before-after-trigger]');
    trigger.onmousedown = function() {
      _drag_init(this);
      return false;
    };
  });


  document.onmousemove = _move_elem;
  document.onmouseup = _destroy;
}

function mobileMenu() {

  var tierActiveSuffix = '--active',
      active = 'active',
      tierTwoActive = 'tier-two'+tierActiveSuffix,
      tierThreeActive = 'tier-three'+tierActiveSuffix,
      openData = 'data-open-panel',
      closeData = 'data-close-panel',
      closeAllData = 'data-close-all',
      mobileMenutrigger = document.querySelector('.header__icon--menu'),
      mobileNavigationContainer = document.querySelector('.mobile-container'),
      openSubMenuTriggers = mobileNavigationContainer.querySelectorAll('['+openData+']'),
      closeSubMenuTriggers = mobileNavigationContainer.querySelectorAll('['+closeData+']'),
      closeAllTriggers = mobileNavigationContainer.querySelectorAll('['+closeAllData+']'),
      moveAside = mobileNavigationContainer.querySelector('.move-aside');

  mobileMenutrigger.addEventListener('click', function(event) {
    closeAndResetMobileMenu();
    mobileNavigationContainer.classList.toggle(active);
  })

  openSubMenuTriggers.forEach(function (openSubMenuTrigger, index) {
    openSubMenuTrigger.addEventListener('click', function(event) {
      event.preventDefault()
      if (openSubMenuTrigger.parentNode.classList.contains(active)) return;
      var linkWrapper = openSubMenuTrigger.parentNode,
          thisTier = openSubMenuTrigger.getAttribute(openData);
      linkWrapper.classList.add(active);
      moveAside.classList.add(thisTier+tierActiveSuffix);
    })
  });

  closeSubMenuTriggers.forEach(function (closeSubMenuTrigger, index) {
    closeSubMenuTrigger.addEventListener('click', function(event) {
      event.preventDefault()
      var linkOuterParent = closeSubMenuTrigger.parentNode.parentNode.parentNode,
          thisTier = closeSubMenuTrigger.getAttribute(closeData);
      linkOuterParent.classList.remove(active);
      moveAside.classList.remove(thisTier+tierActiveSuffix);
    })
  });

  closeAllTriggers.forEach(function (closeAllTrigger, index) {
    closeAllTrigger.addEventListener('click', function(event) {
      event.preventDefault()
      mobileMenutrigger.click();
    })
  });

  function closeAndResetMobileMenu() {
    var allActiveTriggers = moveAside.querySelectorAll('.'+active);

    allActiveTriggers.forEach(function (activeTrigger, index) {
      activeTrigger.classList.remove(active);
    })

    if (mobileNavigationContainer.querySelector('.'+tierTwoActive)) {
      mobileNavigationContainer.querySelector('.'+tierTwoActive).classList.remove(tierTwoActive)
    }

    if (mobileNavigationContainer.querySelector('.'+tierThreeActive)) {
      mobileNavigationContainer.querySelector('.'+tierThreeActive).classList.remove(tierThreeActive)
    }
  }
}

function megaMenu() {

  megaMenuTabContent();

  megaMenuTiers();

  var navItemClass = '.header__menu-item',
      navItems = document.querySelectorAll(navItemClass),
      navItemData = 'data-mega-trigger',
      megaItemClass = '.mega-pane',
      megaItems = document.querySelectorAll(megaItemClass),
      megaItemData = 'data-mega-menu',
      active = 'active';

  navItems.forEach(function (navItem, index) {
    navItem.addEventListener('mouseenter', function() {
      if (navItem.classList.contains(active)) return;
      var thisID = navItem.getAttribute(navItemData),
          megaPane = document.querySelector('['+megaItemData+'="'+thisID+'"]');
      activateDesktopLink(this);      
      activateMegaMenu(megaPane);
    })
    navItem.addEventListener('mouseleave', function() {
      deactivateDesktopLinks();
      deactivateMegaMenu(); 
    })
  });

  megaItems.forEach(function (megaItem, index) {
    megaItem.addEventListener('mouseenter', function() {
      if (megaItem.classList.contains(active)) return;
      var thisID = megaItem.getAttribute(megaItemData),
          megaTrigger = document.querySelector('['+navItemData+'="'+thisID+'"]');
      activateDesktopLink(megaTrigger);      
      activateMegaMenu(this);
    })
    megaItem.addEventListener('mouseleave', function() {
      deactivateDesktopLinks();
      deactivateMegaMenu(); 
    })
  });

  function activateDesktopLink(element) {
    deactivateDesktopLinks();
    if (!element) return;
    element.classList.add(active);
  }

  function activateMegaMenu(element) {
    deactivateMegaMenu();
    if (!element) return;
    element.classList.add(active);
    LazyImages();
  }

  function deactivateDesktopLinks() {
    document.querySelectorAll(navItemClass+'.'+active).forEach(function (activeSibling, index) {
      activeSibling.classList.remove(active);
    });
  }

  function deactivateMegaMenu() {
    document.querySelectorAll(megaItemClass+'.'+active).forEach(function (activeSibling, index) {
      activeSibling.classList.remove(active);
    });
  }
  
  function megaMenuTabContent() {
    var items = document.querySelectorAll('.mega-container .tier-one > li:not(.active--tab)'),
        targetLocation = document.querySelector('.active--tab'),
        activeTab  = 'active';
    if (targetLocation) {
      document.querySelectorAll('.mega-container .tier-one').forEach(function (item, index) {
        firstItem = item.querySelector('li:first-child');
        if (!firstItem.querySelector('ul')) return;
        changeContent(firstItem);
      });
      items.forEach(function (item, index) {
        item.addEventListener('mouseenter', function() {
          if (!item.querySelector('ul') || item.classList.contains(activeTab)) return;
          changeContent(this);
        })
      });
    }
    function changeContent(wrapper) {
      content = wrapper.querySelector('ul').cloneNode(true);
      wrapper.parentNode.querySelectorAll('li').forEach(function (li, index) {
        li.classList.remove(activeTab);
      })
      wrapper.classList.add(activeTab);
      targetLocation.innerHTML = '';
      targetLocation.innerHTML = content.outerHTML;
      LazyImages();
    }
  }

  function megaMenuTiers() {
    var items = document.querySelectorAll('.mega-container .has-sublinks'),
        activeTier  = 'active';

    // document.querySelectorAll('.mega-container .tier-one').forEach(function (item, index) {
    //   activateFirstSublinks(item);
    // });

    items.forEach(function (item, index) {
      item.addEventListener('mouseenter', function() {
        activateTiers(item);
      })
    });

    function activateTiers(element) {
      let el = element.nodeName == 'LI' ? element : element.closest('li'); 
      deactivateTier(el)
      el.classList.add(activeTier);
    }

    function deactivateTier(element) {
      let siblings = getSiblings(element);
      siblings.forEach((activeElement) => {
        activeElement.classList.remove(activeTier);
      });
    }

    function activateFirstSublinks(item) {

      let firstItem = item.querySelector('.has-sublinks');
      checkTiers(firstItem)

      if (!checkTiers(firstItem)) return;
      let secondItem = checkTiers(firstItem).querySelector('.tier-two .has-sublinks');
      checkTiers(secondItem)

      if (!checkTiers(secondItem)) return;
      let thirdItem = checkTiers(secondItem).querySelector('.tier-three .has-sublinks')
      checkTiers(thirdItem)

    }

    function checkTiers(item) {
      if (!item) return;
      item = item.closest('li');
      activateTiers(item);
      return item;
    }

  }
}

function wrapRTEiFrame() {
  var iframes = document.querySelectorAll('.rte iframe,.rte video');
  
  iframes.forEach(function (iframe, index) {
    var iframeWrapper = document.createElement('div');

    iframeWrapper.classList.add('video-inline');
    iframe.parentNode.insertBefore(iframeWrapper, iframe);
    iframeWrapper.appendChild(iframe);
  })
}

function LiquidErrorCheck(arr, string) {
  var checkingFor = (string).toLowerCase().toString(), hasError;
  arr.forEach(function (content, index, arr) {
    var check1 = checkString(content.textContent),
        check2 = checkString(content.outerText),
        check3 = checkString(content.outerHTML),
        check4 = checkString(content.innerText),
        check5 = checkString(content.innerHTML);
    hasError = check1 || check2 || check3 || check4 || check5; 
      if (hasError) {
        arr.length = index + 1;
      }
  })
  function checkString(text) {
    return text.toLowerCase().toString().indexOf(checkingFor) > 0;
  }
  if (hasError) {
    console.log('%c\n!!!!!!!!!!!!!!!!!!! \n\nLiquid error found! \n\n!!!!!!!!!!!!!!!!!!!\n ', 'color: red; font-size: 25px');
  } else {
    console.log('%c No liquid errors found. ', 'color: white; background: green; font-size: 16px');
  }
}


document.addEventListener('DOMContentLoaded', function () {

  // only for testing, should not be left on
  // LiquidErrorCheck([document.head,document.body],'Liquid error');

  VideoRatio()
  
  moveDeliverrPDP();
  moveDeliverrCards();

  wrapRTEiFrame();

  window.addEventListener('scroll', () => {
    simpleScrollAnimations();
  });

  setTimeout(function (argument) {
    simpleScrollAnimations();
  }, 500)

  // setTimeout(function (argument) {
    
    disableDuplicates();
    
    simpleTabs();

    beforeAfterView();

    mobileMenu();
    megaMenu();

  // },1000)

});

var customJSisLoaded = true;

waitForJquery(function () {

  var loadedCount = 0;
  var running = false;
  function ScrollExecute() {
    hasPagination = $('.pagination__item').last();
    if (hasPagination.length > 0) {
      var triggerNextPage = hasPagination[0].offsetTop - ($(window).height() * 1.1);
      if ( triggerNextPage < $(document).scrollTop() && loadedCount < 3 && !running ) {

        running = true;
        var nextPage = $('.pagination__item[aria-current="page"]').closest('li').next().find('.pagination__item').attr("href"),
            infiniteFeed = $('[infinite-feed]');
        
        if (!nextPage || !infiniteFeed) return;

        $.ajax({
          type: 'GET',
          url: nextPage,
          success: function(data) {

            loadedCount++;

            var nextPageItems = $(data).find("[infinite-feed] > *");
            nextPageItems.appendTo($("[infinite-feed]"));

            var nextPagePagination = $(data).find(".pagination__list");
            $(".pagination__list").replaceWith(nextPagePagination);

            LazyImages();
            checkAndLoad('[infinite-feed] link.lazyload',true);

            setTimeout(function () {
              running = false;
            },500)

          },
          dataType: "html"
        });
      }
    }
  }

  $(window).scroll(function() {
    ScrollExecute()
  });

  jQuery.extend(jQuery.expr[':'], {
    focusable: function(el, index, selector) {
      return $(el).is('a, button, :input, label, [tabindex]');
    }
  });


  // Accordian
  $('#tabs-select').on('change', function() {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      // window.location = url; // redirect
      $('a[href="' + url + '"]').trigger('click');
    }
    return false;
  });

  // sidebar links
  $('.accordion-section .sidebar-link').on('click  touch', function() {
    // body...
    $('.accordion-section .sidebar-link').removeClass('active');
    $(this).addClass('active');
  })
  // Accordian
  $(document).on('touch click', '.acc-btn', function(event) {
    var btn = '.acc-btn',
      $ths = $(this),
      animTime = 300,
      justClickedDelay = 500,
      justClicked = false,
      active = 'selected',
      cont = '.acc-content',
      par = '.acc-container',
      ttlTxt = 'h3',
      imgItm = '.img',
      $thsPar = $ths.closest(par),
      clckdIndx = $ths.closest('.site-footer').length == 0 ? $thsPar.find(btn).index($ths) : 0, //must not have '- 1' for section style, if page style stops working a new solution is needed
      $cont = $ths.next(cont),
      inrChld = $cont.children(),
      inrChldHght = inrChld.outerHeight(),
      $thsTtl = $thsPar.find(ttlTxt).eq(clckdIndx),
      $thsImg = $thsPar.find(imgItm).eq(clckdIndx),
      isOpen = $thsTtl.hasClass(active),
      winWidth = $(window).width(),
      clearItem = $('#shopify-section-header'),
      actTab = $(ttlTxt + '.' + active),
      actTabTop = !!actTab ? '' : actTab[0].getBoundingClientRect().top + window.scrollY;

    event.preventDefault();

      // console.log($ths)
      // console.log(clckdIndx)
    if (!!clearItem && !!actTab) {
      actTabTop = actTabTop + clearItem.outerHeight(true) + 15;
    }

    if (!justClicked) {
      justClicked = true;
      if (isOpen) {
        removeClasses();
        openClose();
        // console.log('close')
      } else {
        // console.log('open')
        removeClasses();
        addClasses();
        openClose(true);
        // mobScroll();
      }
      setTimeout(function() {
        justClicked = false;
      }, justClickedDelay);
    }

    function mobScroll() {
      if (winWidth < 750) {
        setTimeout(function() {
          // console.log(openTabDist)
          $([document.documentElement, document.body]).animate({
            scrollTop: openTabDist
          }, animTime);
        }, animTime * 2.5);
      }
    }

    function removeClasses() {
      $thsPar.find(btn + ' ' + ttlTxt).removeClass(active);
      $thsPar.find(btn + ' ' + imgItm).removeClass(active);
    }

    function addClasses() {
      $thsTtl.addClass(active);
      $thsImg.addClass(active);
    }

    function zeroHght() {
      $thsPar.find(cont).stop().animate({ height: 0 }, animTime);
    }

    function setHght() {
      $thsPar.find(cont).eq(clckdIndx).stop().animate({ height: inrChldHght }, animTime);
    }

    function openClose(dir) {
      if (dir == 'open' || dir == true) {
        zeroHght()
        setHght()
      } else {
        setHght()
        zeroHght()
      }
    }
  });
})